import React from 'react';
import { Label, Input, FormFeedback } from 'reactstrap';
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import api from "../../../api";
import { validationInputProps } from "../../../utils/inputValidation";

const UserTextField = ({ label, name, type = "text", disabled = false, autoFocus = false, inputProps = {} }) => (
    <div className="ui-field">
        <Label>{label}</Label>
        <Input disabled={disabled} type={type} name={name} autoFocus={autoFocus} data-auto-focus={autoFocus ? "true" : null} {...inputProps}></Input>
        <FormFeedback className="col-12"></FormFeedback>
    </div>
);

const UserFormSections = ({
    disabled = false,
    includePassword = false,
    departamentoId,
    departamentoPadreId,
    onGrupoChange,
    onSubgrupoChange,
    autoFocusFirstField = false,
}) => (
    <div className="ui-section-grid">
        <section className="ui-section-block">
            <p className="ui-section-label">Datos personales</p>
            <div className="ui-row-2">
                <UserTextField disabled={disabled} autoFocus={autoFocusFirstField} label={"Apellido"} name={"apellido"} />
                <UserTextField disabled={disabled} label={"Nombre"} name={"nombre"} />
            </div>
            <div className="ui-row-2">
                <UserTextField disabled={disabled} label={"DNI"} name={"dni"} inputProps={validationInputProps.dni} />
                <UserTextField disabled={disabled} label={"Teléfono"} name={"telefono"} inputProps={validationInputProps.telefono} />
            </div>
            <div className="ui-row-1">
                <UserTextField disabled={disabled} label={"Email"} name={"email"} />
            </div>
            <div className="ui-row-1">
                <UserTextField disabled={disabled} label={"Domicilio"} name={"domicilio"} />
            </div>
        </section>

        <section className="ui-section-block">
            <p className="ui-section-label">Organización</p>
            <div className="ui-row-1">
                <div className="ui-field">
                    <Label>Grupo</Label>
                    <ParadigmaAsyncSeeker
                        disabled={disabled}
                        fieldName={""}
                        url={api.usuarios.grupos.select}
                        onChange={onGrupoChange}
                        value={departamentoPadreId} />
                    <FormFeedback className="col-12"></FormFeedback>
                </div>
            </div>
            <div className="ui-row-1">
                <div className="ui-field">
                    <Label>Subgrupo</Label>
                    <ParadigmaAsyncSeeker
                        disabled={disabled || !departamentoPadreId}
                        fieldName={"departamento_id"}
                        url={api.usuarios.subgrupos.select + (departamentoPadreId ? "?grupo=" + departamentoPadreId : "")}
                        onChange={onSubgrupoChange}
                        value={departamentoId} />
                    <FormFeedback className="col-12"></FormFeedback>
                </div>
            </div>
        </section>

        <section className="ui-section-block ui-section-span-2">
            <p className="ui-section-label">Datos de login</p>
            <div className="ui-row-2">
                <UserTextField disabled={disabled} label={"Usuario"} name={"username"} />
            </div>
            <div className="ui-row-2">
                {includePassword && <UserTextField label={"Contraseña"} name={"password"} type={"password"} />}
                {includePassword && <UserTextField label={"Repetir Contraseña"} name={"password2"} type={"password"} />}
            </div>
        </section>
    </div>
);

export default UserFormSections;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/UserFormSections.js